/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
import { FC, useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { VariableColumnContainer } from '@marriott/mi-common-static-components';
import { size, Types } from '@marriott/mi-ui-library';
import { shouldUseMockData } from '../../utils/CommonUtils';
import { useMounted } from '../../hooks/useMounted';

export const InfoBlockWrapper: FC<any> = (props: any) => {
  const { model, mbeData, isAuthorMode } = props;
  const [mockdataInAuthorMode, setMockDataInAuthorMode] = useState<any>({});
  const isMounted = useMounted();
  const modelCQitems = {
    ':items': {} as any,
    ':itemsOrder': [] as any,
  };
  const infoBlockData = (isAuthorMode ? mockdataInAuthorMode : mbeData)?.responseObject?.offers?.mbeOfferById?.offers
    ?.moreInfo;
  const infoBlock = infoBlockData?.infoBlock;
  const infoBlockLength = infoBlock?.length;

  // Load mock model dynamically only for dev mode
  const GetMockData = async (isAuthorMode: boolean) => {
    if (shouldUseMockData(isAuthorMode)) {
      const mockModule = await import('./__mock__/InfoBlockAPI.mock');
      return mockModule.InfoBlockAPIdataMock;
    }
    return {};
  };

  useEffect(() => {
    const fetchMockData = async () => {
      const mockData = await GetMockData(isAuthorMode);
      setMockDataInAuthorMode(mockData);
    };

    fetchMockData();
  }, [isAuthorMode]);

  //Create CQItems using API data - Datablock components
  infoBlock?.forEach((infoItemData: any, index: number) => {
    const infoItem = `variable-column-${index}`;
    modelCQitems[':itemsOrder'].push(infoItem);

    modelCQitems[':items'][infoItem] = {
      ':items': {
        datablock: {
          headerTag: 'h2',
          assetVariation: 'iconFont',
          impressionTrack: 'false',
          description: `<p>${infoItemData?.description}</p>\r\n`,
          trackingProperties: {
            enableScrollingBehavior: false,
            trackingDescription: '',
            impressionTrack: false,
            description: `<p>${infoItemData?.description}</p>\r\n`,
            trackingContentPosition: '',
            atCCeVar48: '',
            rightArrowDesc: '',
            cardLocation: '',
            leftArrowDesc: '',
            clickTrack: false,
            location: '',
            merchandisingCategory: 'nonCobrand',
            impressionCount: false,
            trackingTag: '',
            trackingOfferType: '',
          },
          isAuthor: false,
          iconAltText: `${infoItemData?.icon}`,
          ':type': 'mi-aem-common-spa/components/content/datablock',
          headerFontSize: 't-subtitle-m',
          dataBlockVariations: 'icon',
          iconSize: 'large',
          merchandisingCategory: 'nonCobrand',
          impressionCount: 'false',
          iconFontPath: `${infoItemData?.icon}`,
          headingType: 'subtitle',
          orientation: 'horizontal',
          styleclass: 'coral',
          displayRule: 'horizontal',
          header: `${infoItemData?.title}`,
          wcmMode: 'disabled',
        },
      },
      allowedComponents: {
        components: [],
        applicable: false,
      },
      ':type': 'mi-aem-common-spa/components/container',
      ':itemsOrder': [`datablock`],
      columnClassNames: {
        datablock: 'aem-GridColumn aem-GridColumn--default--12',
      },
      gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
      columnCount: 12,
    };
  });

  const updatedModel = {
    contentAlignment: 'left',
    desktopColumns: infoBlockLength > 3 ? '4' : '3',
    tabletColumns: infoBlockLength > 3 ? '2' : '3',
    headerTag: 'h2' as Types.tags,
    headerFontSize: 't-title-m' as size.medium,
    header: infoBlockLength > 0 ? `<p>${model?.title || infoBlockData?.title}</p>\r\n` : '',
    descFontSize: size.medium,
    descriptionText: `${infoBlockData?.disclaimer || ''}`,
    reverseStacking: false,
    mobileColumns: '1',
    modelFactory: {},
    ...modelCQitems,
    ...props?.model,
  };

  const componentProps = {
    model: updatedModel,
    allowedComponents: props?.allowedComponents,
  };

  return isMounted && infoBlockLength > 0 ? <VariableColumnContainer {...componentProps} /> : null;
};

export const InfoBlockConfig = {
  emptyLabel: 'InfoBlock',
  isEmpty: () => true,
  resourceType: 'mi-aem-offers-spa/components/infoblock',
};

export const InfoBlock = (props: any) => (
  <div data-testid="offers-InfoBlock" data-component-name="o-offers-InfoBlock">
    <EditableComponent config={InfoBlockConfig} {...props}>
      <InfoBlockWrapper {...props} />
    </EditableComponent>
  </div>
);
